module.exports = __webpack_public_path__ + "img/calender-icon.dfcc5640.svg";